import getConfig from 'next/config';

export const B2bFavicons = () => {
    const { publicRuntimeConfig } = getConfig();
    const cdnUrl = publicRuntimeConfig.cdnUrl;
    const faviconsBaseUrl = `${cdnUrl}/favicons/b2b`;

    return (
        <>
            <link
                key="b2b-safari-pinned-tab"
                rel="mask-icon"
                href={`${faviconsBaseUrl}/safari-pinned-tab.svg`}
                color="#D90000"
            />
            <link
                key="b2b-favicon-ico"
                rel="shortcut icon"
                href={`${faviconsBaseUrl}/favicon.ico`}
                type="image/x-icon"
            />
            <link
                key="b2b-apple-touch-icon"
                rel="apple-touch-icon-precomposed"
                sizes="180x180"
                href={`${faviconsBaseUrl}/apple-touch-icon.png`}
            />
            <link
                key="b2b-android-chrome-192x192"
                rel="icon"
                type="image/png"
                sizes="192x192"
                href={`${faviconsBaseUrl}/android-chrome-192x192.png`}
            />
            <link
                key="b2b-android-chrome-512x512"
                rel="icon"
                type="image/png"
                sizes="512x512"
                href={`${faviconsBaseUrl}/android-chrome-512x512.png`}
            />
            <link
                key="b2b-favicon-32x32"
                rel="icon"
                type="image/png"
                sizes="32x32"
                href={`${faviconsBaseUrl}/favicon-32x32.png`}
            />
            <link
                key="b2b-favicon-16x16"
                rel="icon"
                type="image/png"
                sizes="16x16"
                href={`${faviconsBaseUrl}/favicon-16x16.png`}
            />
            <link key="b2b-site-webmanifest" rel="manifest" href={`${faviconsBaseUrl}/site.webmanifest`} />
            <meta
                key="b2b-browserconfig"
                name="msapplication-config"
                content={`${faviconsBaseUrl}/browserconfig.xml`}
            />
            <link
                key="b2b-mstile-150x150"
                rel="icon"
                type="image/x-icon"
                sizes="150x150"
                href={`${faviconsBaseUrl}/mstile-150x150.png`}
            />
        </>
    );
};
